import React from 'react';
import styled from 'styled-components';

const AreasOfExpertise = () => {
  return (
    <ServicesContainer>
      <ServicesGrid>
        <div className='top-row'>
          <ServiceTile className='speech'>
            <ServiceIcon>
              <svg
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22H2L12 2Z'
                  stroke='white'
                  strokeWidth='2'
                  fill='white'
                />
                <circle cx='8' cy='12' r='1' fill='#F1C40F' />
                <circle cx='12' cy='12' r='1' fill='#F1C40F' />
                <circle cx='16' cy='12' r='1' fill='#F1C40F' />
              </svg>
            </ServiceIcon>
            <ServiceTitle>Speech & Language Development</ServiceTitle>
          </ServiceTile>

          <ServiceTile className='autism'>
            <ServiceIcon>
              <svg
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <circle
                  cx='12'
                  cy='12'
                  r='10'
                  stroke='white'
                  strokeWidth='2'
                  fill='none'
                />
                <path
                  d='M12 2C12 2 8 6 8 12C8 18 12 22 12 22'
                  stroke='white'
                  strokeWidth='2'
                />
                <circle cx='15' cy='9' r='1' fill='white' />
              </svg>
            </ServiceIcon>
            <ServiceTitle>Autism & Social Communication</ServiceTitle>
          </ServiceTile>

          <ServiceTile className='feeding'>
            <ServiceIcon>
              <svg
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path d='M3 2V22H5V13H7V22H9V2H7V11H5V2H3Z' fill='white' />
                <path
                  d='M15 2C13 2 13 4 13 4V12C13 14 15 14 15 14C17 14 17 12 17 12V4C17 4 17 2 15 2Z'
                  fill='white'
                />
                <rect x='13' y='16' width='4' height='6' fill='white' />
              </svg>
            </ServiceIcon>
            <ServiceTitle>Feeding Therapy</ServiceTitle>
          </ServiceTile>

          <ServiceTile className='aac'>
            <ServiceIcon>
              <svg
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <rect
                  x='3'
                  y='4'
                  width='18'
                  height='14'
                  rx='2'
                  stroke='white'
                  strokeWidth='2'
                  fill='none'
                />
                <rect x='5' y='6' width='3' height='3' fill='white' />
                <rect x='9' y='6' width='3' height='3' fill='white' />
                <rect x='13' y='6' width='3' height='3' fill='white' />
                <rect x='17' y='6' width='2' height='3' fill='white' />
                <rect x='5' y='10' width='3' height='3' fill='white' />
                <rect x='9' y='10' width='6' height='3' fill='white' />
                <rect x='16' y='10' width='3' height='3' fill='white' />
                <rect x='7' y='14' width='10' height='2' fill='white' />
                <path d='M12 20L10 22L14 22L12 20Z' fill='white' />
              </svg>
            </ServiceIcon>
            <ServiceTitle>
              Augmentative & Alternative Communication
            </ServiceTitle>
          </ServiceTile>
        </div>

        <div className='bottom-row'>
          <ServiceTile className='intervention'>
            <ServiceIcon>
              <svg
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <circle cx='8' cy='4' r='2' fill='white' />
                <circle cx='16' cy='4' r='2' fill='white' />
                <path
                  d='M6 8V18H10V8C10 7.45 9.55 7 9 7H7C6.45 7 6 7.45 6 8Z'
                  fill='white'
                />
                <path
                  d='M14 8V18H18V8C18 7.45 17.55 7 17 7H15C14.45 7 14 7.45 14 8Z'
                  fill='white'
                />
                <rect x='4' y='19' width='16' height='2' fill='white' />
                <path
                  d='M2 12L4 10L6 12L8 10L10 12'
                  stroke='white'
                  strokeWidth='1.5'
                  fill='none'
                />
                <rect x='12' y='10' width='2' height='2' fill='white' />
                <rect x='15' y='10' width='2' height='2' fill='white' />
                <rect x='18' y='10' width='2' height='2' fill='white' />
              </svg>
            </ServiceIcon>
            <ServiceTitle>
              Early Childhood & School-Age Intervention
            </ServiceTitle>
          </ServiceTile>

          <ServiceTile className='literacy'>
            <ServiceIcon>
              <svg
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <rect
                  x='4'
                  y='3'
                  width='16'
                  height='18'
                  rx='1'
                  stroke='white'
                  strokeWidth='1.5'
                  fill='none'
                />
                <rect x='4' y='3' width='16' height='4' fill='white' />
                <path d='M7 9H17' stroke='white' strokeWidth='1.5' />
                <path d='M7 11H17' stroke='white' strokeWidth='1.5' />
                <path d='M7 13H15' stroke='white' strokeWidth='1.5' />
                <path d='M7 15H13' stroke='white' strokeWidth='1.5' />
                <path d='M7 17H16' stroke='white' strokeWidth='1.5' />
                <circle cx='8' cy='5' r='0.5' fill='#1e90ff' />
                <circle cx='10' cy='5' r='0.5' fill='#1e90ff' />
                <circle cx='12' cy='5' r='0.5' fill='#1e90ff' />
                <path
                  d='M15 4L16 5L18 3'
                  stroke='#1e90ff'
                  strokeWidth='1'
                  fill='none'
                />
              </svg>
            </ServiceIcon>
            <ServiceTitle>Literacy</ServiceTitle>
          </ServiceTile>

          <ServiceTile className='fluency'>
            <ServiceIcon>
              <svg
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22H2L12 2Z'
                  stroke='white'
                  strokeWidth='2'
                  fill='white'
                />
                <circle cx='8' cy='12' r='1' fill='#F1C40F' />
                <circle cx='12' cy='12' r='1' fill='#F1C40F' />
                <circle cx='16' cy='12' r='1' fill='#F1C40F' />
              </svg>
            </ServiceIcon>
            <ServiceTitle>Fluency</ServiceTitle>
          </ServiceTile>

          <ServiceTile className='accent'>
            <ServiceIcon>
              <svg
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <rect
                  x='3'
                  y='4'
                  width='18'
                  height='14'
                  rx='2'
                  stroke='white'
                  strokeWidth='2'
                  fill='none'
                />
                <rect x='5' y='6' width='3' height='3' fill='white' />
                <rect x='9' y='6' width='3' height='3' fill='white' />
                <rect x='13' y='6' width='3' height='3' fill='white' />
                <rect x='17' y='6' width='2' height='3' fill='white' />
                <rect x='5' y='10' width='3' height='3' fill='white' />
                <rect x='9' y='10' width='6' height='3' fill='white' />
                <rect x='16' y='10' width='3' height='3' fill='white' />
                <rect x='7' y='14' width='10' height='2' fill='white' />
                <path d='M12 20L10 22L14 22L12 20Z' fill='white' />
              </svg>
            </ServiceIcon>
            <ServiceTitle>Accent Modification</ServiceTitle>
          </ServiceTile>
        </div>
      </ServicesGrid>
    </ServicesContainer>
  );
};

export default AreasOfExpertise;

const ServicesContainer = styled.section`
  padding: 20px;
  margin: 0 auto;
  text-align: center;
  background: white;
`;

const ServicesGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  align-items: center;

  .top-row,
  .bottom-row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;
    max-width: 700px;
  }

  @media (max-width: 768px) {
    .top-row,
    .bottom-row {
      gap: 15px;
    }
  }

  @media (max-width: 480px) {
    .top-row,
    .bottom-row {
      gap: 10px;
      display: grid;
      grid-template-columns: 1fr 1fr;
      justify-items: center;
      max-width: 280px;
    }
  }
`;

const ServiceTile = styled.div`
  background: white;
  border-radius: 10px;
  padding: 1rem;
  text-align: center;
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 120px;
  height: 120px;
  flex-shrink: 0;

  &:hover {
    transform: translateY(-2px);
  }

  &.speech {
    background: linear-gradient(135deg, #f1c40f 0%, #f39c12 100%);
  }

  &.autism {
    background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
  }

  &.feeding {
    background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
  }

  &.accent {
    background: linear-gradient(135deg, #2ecc71 0%, #27ae60 100%);
  }

  &.aac {
    background: linear-gradient(135deg, #9b59b6 0%, #8e44ad 100%);
  }

  &.fluency {
    background: linear-gradient(135deg, #9b59b6 0%, #8e44ad 100%);
  }

  &.intervention {
    background: linear-gradient(135deg, #ff7675 0%, #e17055 100%);
  }

  &.literacy {
    background: linear-gradient(135deg, #74b9ff 0%, #0984e3 100%);
  }

  &.gestalt {
    background: linear-gradient(135deg, #74b9ff 0%, #0984e3 100%);
  }

  @media (min-width: 375px) and (max-width: 768px) {
    width: 80px;
    height: 80px;
  }

  @media (max-width: 480px) {
    width: 100px;
    height: 100px;
    padding: 0.5rem;
  }
`;

const ServiceIcon = styled.div`
  margin-bottom: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 30px;
    height: 30px;
  }

  @media (max-width: 480px) {
    margin-bottom: 0.25rem;

    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

const ServiceTitle = styled.h3`
  color: white;
  font-size: 0.75rem;
  font-weight: 600;
  margin: 0;
  line-height: 1.1;
  font-family: 'Georgia', serif;
  text-align: center;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;

  @media (max-width: 480px) {
    font-size: 0.6rem;
    line-height: 1.0;
    -webkit-line-clamp: 2;
  }
`;
